import React from 'react';
import { Formik } from 'formik';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

import { AssociationDto } from 'legacy/groups/types';
import Field from 'legacy/common/components/wysiwyg-form/Field';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { useConfirmStudentEmailCode } from 'legacy/groups/hooks';

interface Props {
  association: AssociationDto;
  onClose: () => void;
}

const EmailCodeValidation = Yup.object({
  code: Yup.string().required('Field is required')
});

function ConfirmCodeForm({ association, onClose }: Props) {
  const { mutate: confirmCode } = useConfirmStudentEmailCode();

  const handleConfirmCode = (values) => {
    confirmCode(
      {
        associationId: association.id,
        code: values.code
      },
      {
        onSuccess: () => {
          toast.success('Email verified successfully 🎉');
          onClose();
        },
        onError: (err) => {
          toast.error(err?.message || 'An error occurred.');
        }
      }
    );
  };

  return (
    <Formik
      enableReinitialize
      onSubmit={handleConfirmCode}
      validationSchema={EmailCodeValidation}
      initialValues={{
        code: ''
      }}
    >
      {({ handleSubmit, errors }) => (
        <>
          <div className="px-4 py-4 flex gap-4 flex-col">
            <p className="font-normal text-base">
              Verification code was sent to the student email provided.
            </p>
            <div>
              <Field
                type="text"
                label="Verification Code"
                id="code"
                name="code"
              />
            </div>
          </div>
          <div className="px-4 border-t-1 pt-6">
            <Button
              type={ButtonType.Primary}
              newRadius
              onClick={handleSubmit}
              disabled={Object.keys(errors).length > 0}
            >
              Verify and Join
            </Button>
          </div>
        </>
      )}
    </Formik>
  );
}

export default ConfirmCodeForm;
